import {
  plainToInstance,
  Transform,
  TransformFnParams,
} from 'class-transformer';

export const JSONToClass = (cls: new () => any) =>
  Transform(
    ({ value }: TransformFnParams) => {
      if (typeof value === 'string') {
        try {
          const parsed = JSON.parse(value) as object;
          if (Array.isArray(parsed)) {
            const instance = parsed.map(
              (item) => plainToInstance(cls, item) as (typeof cls)[],
            );
            return instance;
          }
          return plainToInstance(cls, parsed) as typeof cls;
        } catch (e) {
          return value;
        }
      }
      return value as unknown;
    },
    { toClassOnly: true },
  );
